import type { TFaixaInvestimento, TGetEmpreendimentosFilters } from '@/http/get-empreendimentos.service'

export const empreendimentosKeys = {
  empreendimentos: ['empreendimentos'] as const,
  lista: <TFaixa = TFaixaInvestimento>(filtros: TGetEmpreendimentosFilters<TFaixa>) =>
    [...empreendimentosKeys.empreendimentos, 'lista', filtros] as const,
}
